import { render } from "./proyectoseguimiento.vue?vue&type=template&id=28275788"
import script from "./proyectoseguimiento.vue?vue&type=script&lang=js"
export * from "./proyectoseguimiento.vue?vue&type=script&lang=js"

import "./proyectoseguimiento.vue?vue&type=style&index=0&id=28275788&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__